// ============================================================================
// CANCUN100 — useVersion.js  (Bloque 30: vigilante de versión nueva)
// ----------------------------------------------------------------------------
// Lee /version.json (Cache-Control: no-store en vercel.json; además ?t=Date.now()) al cargar, cada 5 min y
// cada vez que la pestaña vuelve a tener foco (visibilitychange). Si `version` ≠ REACT_APP_VERSION (sello
// del build, scripts/version.js) → hayNueva = true. Sin red o sin archivo: no pasa nada, no se muestra nada.
// Nunca recarga sola: solo informa; "Actualizar" lo decide la persona (window.location.reload()).
// "Más tarde" calla la banda 30 min (sessionStorage). Sin service worker.
// ============================================================================
import { useEffect, useState, useCallback } from 'react';

export const VERSION_APP = process.env.REACT_APP_VERSION || '';
const INTERVALO_MS = 5 * 60 * 1000;
const SILENCIO_MS = 30 * 60 * 1000;
const LLAVE_SILENCIO = 'c100-version-mas-tarde';

const silenciadaHasta = () => { try { return Number(sessionStorage.getItem(LLAVE_SILENCIO) || 0); } catch { return 0; } };

export default function useVersion() {
  const [hayNueva, setHayNueva] = useState(false);
  const [versionNueva, setVersionNueva] = useState('');
  const [silencio, setSilencio] = useState(() => silenciadaHasta() > Date.now());

  const revisar = useCallback(async () => {
    if (!VERSION_APP) return; // build local sin sello: no hay con qué comparar
    try {
      const r = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' });
      if (!r.ok) return;
      const j = await r.json();
      if (j && j.version && j.version !== VERSION_APP) { setVersionNueva(String(j.version)); setHayNueva(true); }
    } catch { /* sin red: silencio */ }
  }, []);

  useEffect(() => {
    revisar();
    const id = setInterval(revisar, INTERVALO_MS);
    const alVolver = () => { if (document.visibilityState === 'visible') revisar(); };
    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('focus', alVolver);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', alVolver); window.removeEventListener('focus', alVolver); };
  }, [revisar]);

  // El silencio de "Más tarde" expira solo (se revisa cada minuto).
  useEffect(() => {
    if (!silencio) return undefined;
    const id = setInterval(() => { if (silenciadaHasta() <= Date.now()) setSilencio(false); }, 60 * 1000);
    return () => clearInterval(id);
  }, [silencio]);

  const masTarde = useCallback(() => { try { sessionStorage.setItem(LLAVE_SILENCIO, String(Date.now() + SILENCIO_MS)); } catch { /* sin storage */ } setSilencio(true); }, []);
  const actualizar = useCallback(() => { window.location.reload(); }, []);

  return { hayNueva: hayNueva && !silencio, versionNueva, versionActual: VERSION_APP, masTarde, actualizar };
}
